'use strict';

var $ = require('jquery');
var _ = require('underscore');
var Marionette = require('backbone.marionette');

var ResponseView = require('./response').default;

export default Marionette.CollectionView.extend({

  className: 'questions-list',

  childView: ResponseView,

  childViewOptions() {
    return {
      client: this.client,
      parentModel: this.model,
    };
  },

  events: {
    'change input': 'updateResponse',
    'change select': 'updateResponse',
    'keyup textarea': 'updateResponse',
  },

  initialize: function (options) {
    this.client = options.client;
    this.setupAnswers();
  },

  setupAnswers: function () {
    if (this.client && this.client.has('answers')) {
      this.answers = this.client.get('answers');
    } else if (window.SETTINGS.copy_multiple_attendees_answers
      && this.model && this.model.has('answers')) {
      this.answers = JSON.parse(JSON.stringify(this.model.get('answers')));
    } else {
      this.answers = {};
    }
    this.model.set('attendeeAnswers', this.answers);
  },

  updateResponse: function (evt) {
    var $element = $(evt.currentTarget);

    var responseId = $element.prop('name').replace('\[\]', '');
    var response = this.collection.get(responseId);

    var question = response.get('question');
    var answer = { qId: question.id, value: [] };
    if (Object.keys(this.answers).includes(question.id.toString())) {
      answer.value = this.answers[question.id].value;
    }

    if (!$element.is(':checkbox')) {
      if ($element.val().length) {
        this.answers[question.id] = answer;
      } else {
        delete this.answers[question.id];
      }
      answer.value = $element.val();
    } else {
      if ($element.prop('checked')) {
        answer.value.push($element.val());
      } else {
        var index = answer.value.indexOf($element.val());
        answer.value.splice(index, 1);
      }

      this.answers[question.id] = answer;
    }

    this.model.set('attendeeAnswers', this.answers);
  },
});
